﻿var ko = require("knockout");
var $ = require("jquery");
var moment = require("moment");

var maskPlaceholder = ' ';
var phoneMask = '(999) 999-9999';
var zipMask = '99999';
var zip4Mask = '9999';
var zipPlus4Mask = '99999[-9999]';
var ssnMask = '***-**-9999';
var extensionMask = '9{*}';
var npi = '9999999999';

var positiveCurrencyMask = "[0-9]*(\\.[0-9][0-9])?";
var currencyMask = "-?[0-9]*(\\.[0-9][0-9])?";
var wholeNumberMask = "\\d*";
var integerMask = "-?\\d*";
var positiveDecimalMask = "\\d*\\.?\\d*";
var decimalMask = "-?\\d*\\.?\\d*";
var numberPlaceholder = ' ';

var handleMask = function (element, datatype) {
    var maskType = $(element).data('datatype') || datatype;
    var rangeMin = $(element).data('val-range-min');
    var rangeMax = $(element).data('val-range-max');
    var regex = $(element).data('regex');

    if (element.type === "tel" && typeof maskType == "string" && maskType === "extension") {
        $(element).inputmask({ mask: extensionMask, placeholder: maskPlaceholder, greedy: true });
    }
    else if (element.type === "tel") {
        $(element).inputmask({ mask: phoneMask, placeholder: maskPlaceholder, greedy: true });
    }
    else if (typeof maskType === "string" && maskType == "zip") {
        $(element).inputmask({ mask: zipMask, placeholder: maskPlaceholder });
    }
    else if (typeof maskType === "string" && maskType == "zip4") {
        $(element).inputmask({ mask: zip4Mask, placeholder: maskPlaceholder });
    }
    else if (typeof maskType === "string" && maskType == "zipPlus4") {
        $(element).inputmask({ mask: zipPlus4Mask, placeholder: maskPlaceholder });
    }
    else if (typeof maskType === "string" && maskType == "ssn") {
        $(element).inputmask({ mask: ssnMask, placeholder: maskPlaceholder });
    }
    else if (typeof maskType === "string" && maskType == "integer") {
        $(element).inputmask("integer", { min: rangeMin, max: rangeMax, rightAlign: false });
    }
    else if (typeof maskType === "string" && maskType == "decimal") {
        $(element).inputmask("decimal", { min: rangeMin, max: rangeMax, rightAlign: false });
    }
    else if (typeof maskType === "string" && maskType == "currency") {
        if (rangeMin >= 0)
            $(element).inputmask("Regex", { regex: positiveCurrencyMask, placeholder: numberPlaceholder });
        else
            $(element).inputmask("Regex", { regex: currencyMask, placeholder: numberPlaceholder });
    }
    else if (typeof maskType === "string" && maskType === "date") {
        $(element).inputmask("mm/dd/yyyy");
    }
    else if (typeof maskType === "string" && maskType === "dateMonthYear") {
        $(element).inputmask("mm/yyyy");
    }
    else if (typeof maskType === "string" && maskType == "regex") {
        $(element).inputmask("Regex", { regex: regex, placeholder: maskPlaceholder });
    }
    else if (typeof maskType === 'string' && maskType === 'npi') {
        $(element).inputmask({ mask: npi, placeholder: '' });
    }
}

var handleDataToString = function (element, value) {
    var retValue = value;

    if (typeof value == "object" && $(element).data("datatype") === "date") {
        retValue = moment(value).format('L');
    }

    return retValue;
}

var handleStringToData = function (element, value, observable) {
    var retValue = value;

    if (observable() instanceof Date && $(element).data("datatype") === "date") {
        retValue = new Date(value);
    }

    return retValue;
}

var hasDataChanged = function (data, newData) {
    if (data instanceof Date && newData instanceof Date) {
        return data.getTime() !== newData.getTime();
    }
    return data !== newData;
}

ko.bindingHandlers.masked = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var mask = allBindingsAccessor().mask || {};
        var regex = allBindingsAccessor().regex || {};
        var datatype = allBindingsAccessor().datatype || null;

        if (typeof mask === "string")
            $(element).inputmask(mask);
        else if (typeof regex === "string")
            $(element).inputmask("Regex", { regex: regex, placeholder: maskPlaceholder });
        else
            handleMask(element, ko.utils.unwrapObservable(datatype));

        ko.utils.registerEventHandler(element, 'blur', function () {
            var observable = valueAccessor();

            if (!ko.isObservable(observable)) throw "The masked binding should be bound to the observable value of the input, not the mask or some other constant";

            var newData = handleStringToData(element, $(element).val(), observable);
            if (hasDataChanged(observable(), newData)) {
                observable(newData);
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).inputmask('remove');
        });
    },
    update: function (element, valueAccessor) {
        $(element).val(handleDataToString(element, ko.utils.unwrapObservable(valueAccessor())));
    }
};
